const api = '/api/v1/u006_p_tran_coms_controller.php';
import axios from 'axios';
export const tran_coms_repository =  {
    get(data){
        return  axios.get(`${api}?SELL_ID=${data}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

